import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["items", "template"];

  connect() {
    this.index = this.itemsTarget.children.length;

    this.sortable = Sortable.create(this.itemsTarget, {
      handle: ".cursor-move",
      animation: 150,
      onEnd: () => this.updatePositions(),
    });

    this.updatePositions();
  }

  add(event) {
    event.preventDefault();

    const html = this.templateTarget.innerHTML.replace(
      /__INDEX__/g,
      this.index
    );
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    this.itemsTarget.appendChild(wrapper.firstElementChild);
    this.index++;
    this.updatePositions();
  }

  remove(event) {
    event.preventDefault();
    const item = event.target.closest(".news-item");

    if (!item) return;

    const destroyInput = item.querySelector('input[name*="_destroy"]');

    if (destroyInput) {
      destroyInput.value = "1";
      item.classList.add("hidden");
    } else {
      item.remove();
    }

    this.updatePositions();
  }

  updatePositions() {
    this.itemsTarget.querySelectorAll(".news-item").forEach((el, index) => {
      const positionInput = el.querySelector(".position-field");
      if (positionInput) positionInput.value = index + 1;
    });
  }
}
